/* eslint-disable class-methods-use-this */
import { ControllerContext } from './controller-context.class';
import { ControllerRootBase } from './controller-root-base.class';
import { ControllerRootOptions } from './types';

export class ComponentControllerBase<
	SerializedDataType = null,
	ContextType extends ControllerContext = ControllerContext
> extends ControllerRootBase<
	SerializedDataType,
	ContextType
> {
	#blueprint: any; // Changed from Blueprint to any to avoid circular dependency

	// eslint-disable-next-line max-params
	constructor (instanceOf = 'ComponentController', blueprint: any = null, options: ControllerRootOptions<SerializedDataType> = {}, context: ContextType = null) {
		super(instanceOf, options, context);
		this.#blueprint = blueprint;
	}
}
